<div class="header">
  <div class="header-tittle">{{ title | translate }}</div>
  <div *ngIf="!hideTime" class="header-date-wrapper">
    <div class="header-time">
      {{ now | date: 'shortDate' }}
    </div>
    <div class="header-date">{{ today }}</div>
  </div>
</div>
